import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/AT';

export const statements: DeepPartial<StatementsConfig> = {
    downloadParamName: 'statementIds',
    formDownload: true,
    tableColumns: {
        DEFAULT: ['NAME', 'TIMESPAN', 'BANKSIGNED', 'DOWNLOAD'],
        CREDIT: ['NAME', 'TIMESPAN', 'BANKSIGNED', 'DOWNLOAD'],
    },
    deliveryChange,
    addAccessTokenToDownloadBody: true,
};
